import { createSelector } from "reselect";
import { unlockSnackbarKey } from "../actions/route";

export const getNotifications = (state) => state.notifications;

export const getNotificationsExceptUnlock = createSelector(
  getNotifications,
  (notifications) =>
    notifications.filter(({ key }) => key !== unlockSnackbarKey)
);
